/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: oermwjefjidrRRHcrxyCjQ
// Component: csXhXQDIqh

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  renderPlasmicSlot,
  SingleBooleanChoiceArg,
  StrictProps,
  useDollarState,
  useTrigger,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: oermwjefjidrRRHcrxyCjQ/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_new_component.css"; // plasmic-import: oermwjefjidrRRHcrxyCjQ/projectcss
import sty from "./PlasmicNewComponentItem.module.css"; // plasmic-import: csXhXQDIqh/css

import EyeSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__EyeSvg"; // plasmic-import: oFYcZi8LU/icon

createPlasmicElementProxy;

export type PlasmicNewComponentItem__VariantMembers = {
  isSelected: "isSelected";
  showControls: "showControls";
  large: "large";
};
export type PlasmicNewComponentItem__VariantsArgs = {
  isSelected?: SingleBooleanChoiceArg<"isSelected">;
  showControls?: SingleBooleanChoiceArg<"showControls">;
  large?: SingleBooleanChoiceArg<"large">;
};
type VariantPropType = keyof PlasmicNewComponentItem__VariantsArgs;
export const PlasmicNewComponentItem__VariantProps = new Array<VariantPropType>(
  "isSelected",
  "showControls",
  "large"
);

export type PlasmicNewComponentItem__ArgsType = {
  title?: React.ReactNode;
  controls?: React.ReactNode;
};
type ArgPropType = keyof PlasmicNewComponentItem__ArgsType;
export const PlasmicNewComponentItem__ArgProps = new Array<ArgPropType>(
  "title",
  "controls"
);

export type PlasmicNewComponentItem__OverridesType = {
  root?: Flex__<"button">;
  image?: Flex__<"div">;
};

export interface DefaultNewComponentItemProps {
  title?: React.ReactNode;
  controls?: React.ReactNode;
  isSelected?: SingleBooleanChoiceArg<"isSelected">;
  showControls?: SingleBooleanChoiceArg<"showControls">;
  large?: SingleBooleanChoiceArg<"large">;
  className?: string;
}

const $$ = {};

function PlasmicNewComponentItem__RenderFunc(props: {
  variants: PlasmicNewComponentItem__VariantsArgs;
  args: PlasmicNewComponentItem__ArgsType;
  overrides: PlasmicNewComponentItem__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "isSelected",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.isSelected,
      },
      {
        path: "showControls",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.showControls,
      },
      {
        path: "large",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.large,
      },
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const [isRootFocus, triggerRootFocusProps] = useTrigger("useFocused", {});
  const triggers = {
    focus_root: isRootFocus,
  };

  const styleTokensClassNames = _useStyleTokens();

  return (
    <button
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "button",
        "button__oermw",
        "root_reset_oermwjefjidrRRHcrxyCjQ",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootisSelected]: hasVariant($state, "isSelected", "isSelected"),
          [sty.rootlarge]: hasVariant($state, "large", "large"),
          [sty.rootshowControls]: hasVariant(
            $state,
            "showControls",
            "showControls"
          ),
        }
      )}
      data-plasmic-trigger-props={[triggerRootFocusProps]}
    >
      <div
        data-plasmic-name={"image"}
        data-plasmic-override={overrides.image}
        className={classNames("all", sty.image, {
          [sty.imageisSelected]: hasVariant($state, "isSelected", "isSelected"),
          [sty.imagelarge]: hasVariant($state, "large", "large"),
          [sty.imageshowControls]: hasVariant(
            $state,
            "showControls",
            "showControls"
          ),
        })}
      />

      <div
        className={classNames("all", sty.freeBox__bTp1S, {
          [sty.freeBoxisSelected__bTp1SkSSyv]: hasVariant(
            $state,
            "isSelected",
            "isSelected"
          ),
          [sty.freeBoxlarge__bTp1S4PZy]: hasVariant($state, "large", "large"),
          [sty.freeBoxshowControls__bTp1Sz2I0H]: hasVariant(
            $state,
            "showControls",
            "showControls"
          ),
        })}
      >
        {renderPlasmicSlot({
          defaultContents: "Component title",
          value: args.title,
          className: classNames(sty.slotTargetTitle, {
            [sty.slotTargetTitleisSelected]: hasVariant(
              $state,
              "isSelected",
              "isSelected"
            ),
            [sty.slotTargetTitleshowControls]: hasVariant(
              $state,
              "showControls",
              "showControls"
            ),
          }),
        })}
        {(hasVariant($state, "showControls", "showControls") ? true : false)
          ? renderPlasmicSlot({
              defaultContents: (
                <EyeSvgIcon
                  className={classNames("all", sty.svg__x9Bqd)}
                  role={"img"}
                />
              ),

              value: args.controls,
            })
          : null}
      </div>
      {(triggers.focus_root ? true : false) ? (
        <div className={classNames("all", sty.freeBox__uUyA)} />
      ) : null}
    </button>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "image"],
  image: ["image"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "button";
  image: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicNewComponentItem__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicNewComponentItem__VariantsArgs;
    args?: PlasmicNewComponentItem__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicNewComponentItem__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicNewComponentItem__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicNewComponentItem__ArgProps,
          internalVariantPropNames: PlasmicNewComponentItem__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicNewComponentItem__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicNewComponentItem";
  } else {
    func.displayName = `PlasmicNewComponentItem.${nodeName}`;
  }
  return func;
}

export const PlasmicNewComponentItem = Object.assign(
  // Top-level PlasmicNewComponentItem renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    image: makeNodeComponent("image"),

    // Metadata about props expected for PlasmicNewComponentItem
    internalVariantProps: PlasmicNewComponentItem__VariantProps,
    internalArgProps: PlasmicNewComponentItem__ArgProps,
  }
);

export default PlasmicNewComponentItem;
/* prettier-ignore-end */
